import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllInvoicesDataGrid } from "src/components/views/erp/sales/invoicing/AllInvoicesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/invoicing/allInvoices")({
	staticData: { title: i18n.t("all_invoices"), legacyViewKey: "allInvoicesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllInvoicesDataGrid />;
}
